import { render, staticRenderFns } from "./CaseTab.vue?vue&type=template&id=197129c6"
import script from "./CaseTab.vue?vue&type=script&lang=js"
export * from "./CaseTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports